import React from "react";
import AgentSideBar from "../AgentSideBar/AgentSideBar";
import AgentHeader from "../AgentHeader/AgentHeader";
import ImageEditor from "../../../CustomComponents/BrandAsset/ImageEditor";


function BrandAsset() {
    return (
        <div id="Listingholidays">
            {/* <PageMetaData
        title="Mountain Mysteries"
        description="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        keywords="hotel management, RevCatalyst, property optimization"
      /> */}
            <div className="sidebar_main_div new_sidebar_main_div">
                <AgentSideBar />
                <div className="agent-info-container">
                    <AgentHeader showSelectProperty={true} vendorProperty={false} />
                    <section className="w-full" style={{ backgroundColor: '#F3F3F3' }}>
                        {/* <div className="common_background mt-10"> */}
                        <h4 style={{ margin: '15px 0', fontSize: '20px' }}>Image Editor</h4>
                        <div className="profile_content Profile">
                            <ImageEditor />
                        </div>
                        {/* </div> */}
                    </section>
                </div>
            </div>
        </div>
    );
}


export default BrandAsset;